import constants from './auth.constants'
import AuthService from './auth.service'

// import history

const authActions = {
	login,
	logout
}

function login(username, password) {
	return dispatch => {
		dispatch(request({ username }))

		AuthService.login(username, password)
		.then(
			user => {
				dispatch(success(user));
			},
			error => {
				dispatch(failure(error.toString()))
			}
		);

 		function request(user) { return { type: constants.AUTH_LOGIN_REQUEST, user} }
 		function success(user) { return { type: constants.AUTH_LOGIN_SUCCESS, user} }
 		function failure(error) { return { type: constants.AUTH_LOGIN_FAILURE, error} }
	}
}

function logout(message) {
	AuthService.logout()

	return { 
		type: constants.AUTH_LOGOUT, 
		message: message
	}
}

export default authActions;


// WEBPACK FOOTER //
// ./src/modules/auth/auth.actions.js